import React from 'react';
import './App.css';
import BenchmarkAnalyzer from './BenchmarkAnalyzer';

function App() {
  return (
    <div className="App">
      <BenchmarkAnalyzer />
    </div>
  );
}

export default App;